import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { fontWeight, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { globalStyle, style } from '@vanilla-extract/css';
import {
  containerMaxWidth,
  containerPadding,
  containerPaddingMobile,
} from '@/routes/_auth/style-vars';

export const footerContainer = style([
  {
    display: 'flex',
    justifyContent: 'space-between',
    gap: space.s10,
    maxWidth: containerMaxWidth,
    margin: '0 auto',
    width: '100%',
  },
  responsiveStyle({
    mobile: {
      ...typography.labelSm,
      fontWeight: fontWeight.regular,
      marginTop: space.s14,
      padding: containerPaddingMobile,
      alignItems: 'start',
    },
    tablet: {
      ...typography.labelMd,
      fontWeight: fontWeight.regular,
      marginTop: space.s40,
      padding: `${space.s20}px ${containerPadding}px`,
      alignItems: 'center',
    },
  }),
]);

export const linksContainer = style([
  {
    display: 'grid',
    rowGap: space.s10,
  },
  responsiveStyle({
    mobile: {
      gridTemplateColumns: 'repeat(2, min-content)',
      columnGap: space.s20,
    },
    tablet: {
      gridTemplateColumns: 'repeat(4, min-content)',
      columnGap: space.s32,
    },
  }),
]);

export const footerLink = style([
  {
    color: 'inherit',
    ':hover': {
      textDecoration: 'underline',
    },
  },
]);

globalStyle(`${linksContainer} > a`, {
  whiteSpace: 'nowrap',
});
